export default {
    font: 'Lato',

    feed: {
        include_nsfw_submissions: false,
        excludeLikedSubmissions: false,
        excludeBookmarkedSubmissions: false,
        submissionsFilter: 'all',
        submissionsType: 'All'
    },

    rightSidebar: {
        channelsFilter: 'subscribed',
        channelsLimit: 15,
        showChannelAvatars: true,
        color: 'Gray'
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/settings.js